<template>
  <div>
    <div>
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Category</v-card-title>
          <v-btn class="ml-auto" icon @click="close()">
            <v-icon small class="white--text">mdi-window-close</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mb-6 mt-4 ml-3">
          <v-btn
            class="mr-2 white--text"
            color="channelbtn"
            depressed
            @click.stop="addCategoryDialog = true"
            :disabled="addBtnDisabled"
          >
            Add
          </v-btn>
          <v-btn
            class="mr-2 "
            color="error"
            depressed
            @click.stop="deleteConfirmDialog = true"
            :disabled="btnDisabled"
          >
            Remove
          </v-btn>
          <v-btn
            class="mr-2 white--text "
            color="light-blue darken-4"
            depressed
            @click.stop="openEditCategoryDialog()"
            :disabled="btnDisabled"
          >
            Edit
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="categories"
          :search="search"
          class="border"
          show-select
          :hide-default-footer="false"
          :single-select="singleSelect"
          v-model="selectedCategory"
        >
        </v-data-table>
      </v-card>
    </div>
    <!-- 그룹등록 모달창 -->
    <v-dialog v-model="addCategoryDialog" max-width="400px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Add Category</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeAddCategoryDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7 pb-0">
          <v-form ref="form" v-model="valid" v-on:submit.prevent>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  color="channel"
                  label="Category Name"
                  :rules="[categoryNameRules]"
                  v-model="categoryName"
                  :error-messages="errors"
                  @keydown.enter="createCategory"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-text-field
                  color="channel"
                  label="Category Info"
                  :rules="[categoryInfoRules]"
                  v-model="categoryInfo"
                  :error-messages="errors"
                  @keydown.enter="createCategory"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="createCategory"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeAddCategoryDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 그룹이름편집 모달창 -->
    <v-dialog v-model="editCategoryDialog" max-width="400px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Edit Category</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeEditCategoryDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7 pb-0">
          <v-form ref="form2" v-model="valid">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  color="channel"
                  label="Category Name"
                  :rules="[categoryEditNameRules]"
                  v-model="categoryEditName"
                  :error-messages="errors"
                  @keyup.enter="editCategory"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-text-field
                  color="channel"
                  label="Category Info"
                  :rules="[categoryEditInfoRules]"
                  v-model="categoryEditInfo"
                  :error-messages="errors"
                  @keydown.enter="createCategory"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="editCategory"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeEditCategoryDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 삭제확인 모달창 -->
    <v-dialog v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon color="error" @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the Category?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteCategory()"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { listCategories, listUserRolesByRole } from "@/graphql/Query";
import {
  createCategory,
  updateCategory,
  deleteCategory
} from "@/graphql/Mutation";

export default {
  name: "CategoryList",

  data: () => ({
    addCategoryDialog: false,
    editCategoryDialog: false,
    deleteConfirmDialog: false,
    membersEditDialog: false,
    singleSelect: true,
    valid: true,
    categoryName: "",
    categoryEditName: "",
    categoryInfo: "",
    categoryEditInfo: "",
    errors: [],
    search: "",
    userSearch: "",
    selectedId: "",
    users: [],
    deleteMembers: [],
    createMembers: [],
    selectedCategoryMembers: [],
    selectedCategory: [], // 그룹리스트에서 편집, 삭제를 위해 선택된 그룹
    selectedUsers: [],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "category_name"
      },
      { text: "Info", value: "category_info" },
      { text: "Id", value: "id" }
    ],
    headersUser: [
      {
        text: "email",
        align: "start",
        value: "email"
      }
    ],
    categories: [],
    categoryHeaders: [{ text: "Category", value: "name" }]
  }),

  created() {
    this.initialize();
  },

  computed: {
    btnDisabled: function() {
      return this.selectedCategory.length <= 0;
    },
    addBtnDisabled: function() {
      return this.categories.length >= 100;
    },
    categoryNameMembersEdit: function() {
      if (this.selectedCategory.length > 0) {
        return this.selectedCategory[0].category_name;
      }
      return "";
    }
  },
  methods: {
    close() {
      this.selectedCategory = [];
      this.$emit("onCloseContentCategoryDialog");
    },
    async initialize() {
      this.categories = [];
      await this.getListCategories();
      console.log("category initialize");
    },
    CategorySave() {
      this.addCategoryDialog = false;
    },

    async deleteCategory() {
      try {
        console.log();
        const channel_id = this.$store.state.channelId;
        const id = this.selectedCategory[0].id;
        console.log({ channel_id, id });
        const { data } = await this.$apollo.mutate({
          mutation: deleteCategory,
          variables: {
            input: {
              channel_id,
              id
            }
          },
          fetchPolicy: "no-cache"
        });
        if (data && data.deleteCategory) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Delete Category [${this.categoryNameMembersEdit}] `
          });
          this.categories = this.categories.filter(function(item) {
            return item.id != id;
          });
        }
      } catch (e) {
        // console.log("[CategoryList] DeleteCategory failed", e);
        this.$store.dispatch("logger", {
          menu: "Categories",
          level: "error",
          message: `Failed to Delete Category [${this.categoryNameMembersEdit}]`
        });
      }
      this.deleteConfirmDialog = false;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteCategoryDialog = true;
    },
    openEditCategoryDialog() {
      this.categoryEditName = this.selectedCategory[0].category_name;
      this.categoryEditInfo = this.selectedCategory[0].category_info;
      this.editCategoryDialog = true;
    },
    closeEditCategoryDialog() {
      this.$refs.form2.resetValidation();
      this.$refs.form2.reset();
      this.editCategoryDialog = false;
    },
    closeAddCategoryDialog() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.addCategoryDialog = false;
    },
    async getListCategories() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const limit = undefined;
      const nextToken = undefined;
      try {
        const { data } = await this.$apollo.query({
          query: listCategories,
          variables: {
            channel_id: this.$store.state.channelId,
            limit: limit,
            nextToken: nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[CategoryList]", data);
        this.categories = data.listCategories.items;
        console.log(this.categories);
        this.categories.sort((a, b) =>
          a.category_name > b.category_name ? 1 : -1
        );
      } catch (e) {
        console.log("[CategoryList] listCategory failed");
      }
    },
    async createCategory() {
      /**
       * 채널에 해당그룹 생성하기
       */
      if (!this.$refs.form.validate()) return;

      try {
        console.log(this.$store.state.channelId, this.categoryName);
        const { data } = await this.$apollo.mutate({
          mutation: createCategory,
          variables: {
            input: {
              channel_id: this.$store.state.channelId,
              category_name: this.categoryName,
              category_info: this.categoryInfo
            }
          }
        });
        if (data && data.createCategory) {
          this.categories.push(data.createCategory);
          this.categories.sort((a, b) =>
            a.category_name > b.category_name ? 1 : -1
          );

          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Add Category ${data.createCategory.category_name}`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "error",
            message: `Fail to Add Category ${this.category_name} `
          });
        }
      }
      this.closeAddCategoryDialog();
      this.$emit("onUpdateCategoryList", this.categories);
    },
    async editCategory() {
      /**
       * 채널에 해당그룹 수정하기
       */
      if (!this.$refs.form2.validate()) return;

      try {
        console.log(
          this.$store.state.channelId,
          this.categoryEditName,
          this.selectedCategory[0].id,
          this.categories
        );
        const channel_id = this.$store.state.channelId;
        const category_name = this.categoryEditName;
        const category_info = this.categoryEditInfo;
        const id = this.selectedCategory[0].id;

        const { data } = await this.$apollo.mutate({
          mutation: updateCategory,
          variables: {
            input: {
              channel_id,
              category_name,
              category_info,
              id
            }
          }
        });

        if (data && data.updateCategory) {
          const o = this.categories.find(obj => obj.id == id);
          o.category_name = data.updateCategory.category_name;
          o.category_info = data.updateCategory.category_info;
          this.categories.sort((a, b) =>
            a.category_name > b.category_name ? 1 : -1
          );

          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "success",
            message: `Success to Update Category ${this.selectedCategory[0].category_name} => ${data.updateCategory.category_name}`
          });

          this.$emit("onUpdateCategoryList", this.categories);
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Categories",
            level: "error",
            message: `Fail to Update Category ${this.selectedCategory[0].category_name} => ${this.categoryEditName} `
          });
        }
      }
      this.closeEditCategoryDialog();
    },

    categoryNameRules(v) {
      if (!v) return "Category name is required";
      if (v.length > 30) return "Category name must be less than 30 characters";
      return true;
    },
    categoryEditNameRules(v) {
      if (!v) return "Category name is required";
      if (v.length > 30) return "Category name must be less than 30 characters";
      return true;
    },
    categoryInfoRules(v) {
      if (v && v.length > 10)
        return "Category info must be less than 10 characters";
      return true;
    },
    categoryEditInfoRules(v) {
      if (v && v.length > 10)
        return "Category info must be less than 10 characters";
      return true;
    },
    async getListUsers() {
      /**
       * userRole을 role을 기준으로 가져오기
       * 채널##gu 로 채널유저 가져와 이메일 정렬 후 users에 입력
       */
      const limit = undefined;
      const nextToken = undefined;
      const channelId = this.$store.state.channelId;
      const categoryName = this.categoryNameMembersEdit;
      const userRoleForFull = `${channelId}##gu`;
      const userRoleForSelectedCategory = `${channelId}#${categoryName}#gu`;

      // 채널 전체 유저 가져오기
      const { data } = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForFull,
          limit: limit,
          nextToken: nextToken
        },
        fetchPolicy: "no-cache"
      });

      const items = data.listUserRolesByRole.items;
      this.users = items;
      console.log("users", this.users);

      // 선택 그룹에 해당하는 유저 가져오기
      const result = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: userRoleForSelectedCategory
        },
        fetchPolicy: "no-cache"
      });

      if (result && result.data.listUserRolesByRole.items) {
        this.selectedCategoryMembers = [
          ...result.data.listUserRolesByRole.items
        ];
        this.selectedUsers = result.data.listUserRolesByRole.items;
      }
      console.log("selectedCategoryMembers", this.selectedCategoryMembers);
    }
  }
};
</script>
<style>
.userslist {
  max-height: 200px;
}
</style>
